import React, { useState, useEffect, Fragment } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { uploadSingleFileToS3 } from "../api/fileUploadApi";
import { useSelector, useDispatch } from "react-redux";
import LoaderSpinner from "./LoaderSpinner";
import UploadSuccessIcon from "./UploadSuccessIcon";
import UploadFailureIcon from "./UploadFailureIcon";
import Popover from '@mui/material/Popover';
import Typography from '@mui/material/Typography';

function FileUpload({
  showUploadStatuses = true,
  isDisabled = false,
  fieldName,
  setParentField,
  setSelectedFiles,
  selectedFiles = [],
  formik,
  fileUploadStatus,
  fileUploadRef,
  uploadedFileUrl = "",
}) {
  const [isUploading, setisUploading] = useState(false);
  const [isUploadSuccess, setisUploadSuccess] = useState(false);
  const [isUploadFailure, setisUploadFailure] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    if (showUploadStatuses) fileUploadRef.current = resetUploadStatuses;
  }, []);

  const handleFileUpload = (event) => {
    // console.log("event.target.name", event.target.name);
    // console.log("event.currentTarget.files[0]", event.currentTarget.files[0]);
    let newFiles = [...selectedFiles];
    // const newFile = {
      // category: event.target.name,
    //   file: event.currentTarget.files[0],
    // };
    // dispatch(uploadSingleFileToS3(event.currentTarget.files[0], event.target.name, fileUploadSuccessCallback));
    // const existingFile = selectedFiles.find(
    //   (file) => file.category === event.target.name
    // );
    // if (existingFile) {
    //   const filteredFiles = selectedFiles.filter(
    //     (file) => file.category !== event.target.name
    //   );
      // if (!newFile.file) {
      //   newFiles = [...filteredFiles];
      //   formik.setFieldValue(event.target.name, false);
      // } else {
      //   newFiles = [...filteredFiles, newFile];
      //   formik.setFieldValue(event.target.name, true);
      // }
    // } else {
    //   newFiles = [...newFiles, newFile];
      // formik.setFieldValue(event.target.name, true);
    // }
    // console.log("newFiles",newFiles);
    setSelectedFiles(newFiles);
    fileUploadStatus(event.currentTarget.files[0], fieldName, {
      uploading: () => setisUploading(true),
      uploadSuccess: fileUploadSuccessCallback,
      uploadFailure: fileUploadFailureCallback,
    });
  };

  const resetUploadStatuses = () => {
    console.log("file upload resetUploadStatuses");
    setisUploading(false);
    setisUploadSuccess(false);
    setisUploadFailure(false);
  };

  const fileUploadSuccessCallback = () =>
    // resp, field
    {
      toast.success("Upload success.");
      setisUploadSuccess(true);
      setisUploading(false);
      setisUploadFailure(false);
      // console.log("success", resp);
      // setParentField(field, resp.link);
    };
  const fileUploadFailureCallback = () =>
    // resp
    {
      toast.error("Error uploading, please try again!");
      setisUploadFailure(true);
      setisUploading(false);
      setisUploadSuccess(false);
      // console.log("failure", resp);
    };

  const [openPopover, setOpenPopover] = useState(null);

  const handlePopoverOpen = (event) => {
    setOpenPopover(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setOpenPopover(null);
  };
  
  const renderDocPreview = (link) => {
    return (
      <Popover
              id="mouse-over-popover"
              sx={{
                pointerEvents: 'none',
              }}
              open={Boolean(openPopover)}
              anchorEl={openPopover}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              onClose={handlePopoverClose}
              disableRestoreFocus
            >
              <iframe title={`${link}__`} src={link} height="350" width="100%" className="mt-2"/>
            </Popover>
    )
  }

  return (
    <div>
      <div>
        {/* 1kb = 1024 bytes (binary) 1MB = 1,048,576 bytes(binary) */}
        <input
          disabled={isDisabled}
          id="file"
          name={fieldName}
          type="file"
          accept="application/pdf, image/png, image/jpeg"
          onChange={(event) => {
            if (event.currentTarget?.files[0]?.size > 204800) {
              alert("File size larger than allowed (200kb)!");
              return true;
            } else handleFileUpload(event);
          }}
        />
      </div>
      {!isUploadSuccess && uploadedFileUrl && (
        <Fragment>
          <UploadSuccessIcon />&nbsp;
          <a href={uploadedFileUrl} rel="noopener noreferrer" target="_blank" 
          onMouseEnter={handlePopoverOpen}
          onMouseLeave={handlePopoverClose}
          >
            Link
            {renderDocPreview(uploadedFileUrl)}
          </a>
        </Fragment>
      )}
      {isUploading && <LoaderSpinner />}
      {isUploadSuccess && (
        <Fragment>
          <UploadSuccessIcon />&nbsp;
          {uploadedFileUrl !== "" && (
            <a href={uploadedFileUrl} rel="noopener noreferrer" target="_blank">
              Link
            </a>
          )}
        </Fragment>
      )}
      {isUploadFailure && <UploadFailureIcon />}

      <ToastContainer />
    </div>
  );
}

export default FileUpload;
